import { render } from "./ServiceProviderActions.vue?vue&type=template&id=50cab3e3&ts=true"
import script from "./ServiceProviderActions.vue?vue&type=script&lang=ts"
export * from "./ServiceProviderActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
